import { netsparkAxios } from 'core/services/HTTPService';
import { IEngagementsTotalItem } from 'pages/Dashboard/Dashboard.models';
import { getProjectStatusUrl } from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

const getProjectStatus = (signal: AbortSignal, params: TPeriod) => netsparkAxios
  .get<IEngagementsTotalItem[]>(getProjectStatusUrl, { signal, params });

export default getProjectStatus;
